import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/**
* VuwFuncBlock (extends VuwerComponent)
* @options
* - {Object} buttonText
*/
vuwer.appendKlass("VuwFuncBlock", {
	buttonText: {},
	
	/**
	 * ボタン生成関数
	 * @param {Object} buttonConfig
	 * @param {String} prefix
	 * @returns $Object
	 */
	_createButtons(buttonConfig, prefix) {
		if( !u_.isObject(buttonConfig) ) {
			throw new TypeError("arguments[0] must be object.");
		}
		
		u_.isString(prefix) || (prefix = "");
		
		return $.fn.append.apply( $("<div/>"), Object.keys(buttonConfig).map(k => {
			const data = buttonConfig[k];
			const keyStr = `${prefix}-${k}`.replace(/^-/, "");
			
			if( u_.isObject(data) ) {
				return this._createButtons(data, keyStr);
			} else {
				return $("<a/>").addClass(`btn btn-${keyStr}`).attr("href", "./").append(
					$("<span/>").text(data)
				);
			}
		}) ).children();
	},
	
	/**
	 * DOMやメンバ変数のリフレッシュ関数
	 */
	refresh() {
		this.$self.empty().append( this._createButtons(this.buttonText) );
	}
});
